import React from 'react'
import { CModal, CModalHeader, CModalBody, CModalTitle, CSpinner, CButton } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilX } from '@coreui/icons'
import MemberDetailsCard from './MemberDetailsCard'
import './MemberDetailModal.scss'

const MemberDetailModal = ({ visible, onClose, member, isAdmin, isLoading }) => {
  if (!member) return null

  return (
    <>
      <CModal
        visible={visible}
        onClose={onClose}
        size="xl"
        className="modal-member-details"
        alignment="center"
      >
        <CModalHeader closeButton>
          <CModalTitle>Détails du membre</CModalTitle>
        </CModalHeader>
        <CModalBody>
          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center py-5">
              <CSpinner color="primary" />
              <span className="ms-3">Chargement des informations...</span>
            </div>
          ) : (
            <MemberDetailsCard
              member={member}
              isAdmin={isAdmin}
              onClose={onClose}
              hideCloseButton
            />
          )}
        </CModalBody>
      </CModal>

      {/* Bouton de fermeture flottant pour mobile et desktop */}
      {visible && (
        <CButton
          className="floating-close-button"
          onClick={onClose}
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            width: '56px',
            height: '56px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #0084ff, #0066cc)',
            border: 'none',
            boxShadow: '0 4px 12px rgba(0, 132, 255, 0.4)',
            zIndex: 10000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
            transition: 'all 0.3s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'scale(1.1) rotate(90deg)'
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 132, 255, 0.6)'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'scale(1) rotate(0deg)'
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 132, 255, 0.4)'
          }}
        >
          <CIcon icon={cilX} size="xl" style={{ color: 'white' }} />
        </CButton>
      )}
    </>
  )
}

export default MemberDetailModal
